
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { value } from "./VoiceToTextSlice";


import axios from "axios";
import { useEffect } from "react";
import { toast } from "react-toastify";
import power from "./Images/power.png";

import { MenuItem, Select } from "@mui/material";
import liznr_logo from "./Images/Liznr-final.png";
import Loader from "./Loader/Loader.jsx";
import MeetingPopover from "./utilities/MeetingPopover.jsx";
import CalendarMeetings from "./calendar/CalendarMeetings";
import CreditsBadge from "./Pages/credits/credits";
import "./createRoom.css";
import * as microsoftTeams from "@microsoft/teams-js"

axios.defaults.withCredentials = true;

const CreateRoom = () => {
  const [input, setInput] = useState({});
  // Handler to set roomcode when skipping calendar meetings
  const handleSkipCalendarMeetings = () => {
    setSkipCalendarMeetings(true);
    // const room_code = sessionStorage.getItem("meetingCode");
    // setInput({ roomcode: room_code });
  };
  const navigate = useNavigate();
  // const [authenticated, setAuthenticated] = useState();

  const [meetUrl, setMeetUrl] = useState("");
  // const [loginMessage, setLoginMessage] = useState(false);

  // const [isLoading, setIsLoading] = useState(false); // For local make it true
  const [authLoaded, setAuthLoaded] = useState(false);
  const [orgLoaded, setOrgLoaded] = useState(false);
  const [googleCalendarMeetings, setGoogleCalendarMeetings] = useState([]);
  const [skipCalendarMeetings, setSkipCalendarMeetings] = useState(false);
  const [calendarLoaded, setCalendarLoaded] = useState(skipCalendarMeetings);

  // const [access_token, setAccessToken] = useState(null);
  // const [refresh_token, setRefreshToken] = useState(null);
  const [hasOrganization, setHasOrganization] = useState(false);

  // API
  const ext_backend = process.env.REACT_APP_PORT_8000;
  const auth_backend = process.env.REACT_APP_PORT_8001;
  const dashboard_backend = process.env.REACT_APP_DASHBOARD_BACKEND;
  const dashboard = process.env.REACT_APP_DASHBOARD;


  // commented for development / local purpose Prosenjit

 const getMSMeetingId = async () => {
  try {
    // Ensure Teams SDK is initialized and wait for it
    await microsoftTeams.app.initialize();

    // Notify Teams that the iframe loaded successfully (call within 30s)
    try { microsoftTeams.app.notifySuccess(); } catch (e) { /* ignore if not available */ }

    const context = await microsoftTeams.app.getContext();
   

    const tenantID = context?.user?.tenant?.id ?? "";
    const userId = context?.user?.id ?? "";
    const chatId = context?.chat?.id ?? "";

    // Safer meeting id extraction using regex for expected format:
    // e.g. "19:meeting_<meetingId>@thread.v2"
    let meetingId = null;
    const m = chatId.match(/meeting_([^@]+)/);
    if (m && m[1]) {
      meetingId = m[1].substring(0, 10); // if you truly want first 10 chars
    }

    const final = `https://teams.microsoft.com/v2/?meetingjoin=true#/l/meetup-join/${encodeURIComponent(chatId)}/0?context=${encodeURIComponent(JSON.stringify({
      Tid: tenantID,
      Oid: userId
    }))}`;

    sessionStorage.setItem("msLink", final);

    if (!meetingId) {
      console.warn("Could not parse meetingId from chatId:", chatId);
      return null;
    }
    if(meetingId){

        setMeetUrl(meetingId)
    }
    // Obtain server-side token (your endpoint) OR use Teams SDK getAuthToken
    // Option A: Use Teams SDK (recommended for client-side token retrieval)
    // const teamsToken = await microsoftTeams.authentication.getAuthToken();
    // Use backend OBO to exchange teamsToken for Graph token.

    // Option B: Call your backend to get the required token (OBO or app token)
    // const authResp = await axios.post(`${auth_backend}/ms-token/`);
    // const accessToken = authResp?.data?.access_token;
    // if (!accessToken) {
    //   console.error("No access_token in response", authResp?.data);
    //   return null;
    // }
    // const decoded = jwtDecode(accessToken);
    // console.log("Access Token (decoded):", decoded);

    // // Store server-provided token if you need it later
    // sessionStorage.setItem("access_token", accessToken);

    // // Call your backend proxy to fetch meeting info from Graph or internal APIs.
    // // IMPORTANT: axios.get(url, config) expects a single config object.
    // const proxyResp = await axios.get(`${ext_backend}/proxy-ms-graph/`, {
    //   headers: {
    //     // Choose the header your backend expects:
    //     // If your backend expects the token in Authorization:
    //     Authorization: `Bearer ${accessToken}`

    //     // OR if your proxy expects custom header ms-access:
    //     // 'ms-access': accessToken
    //   },
    //   // If your backend requires cookies:
    //   // withCredentials: true
    // });

    // console.log("Proxy response:", proxyResp.data);
    // return accessToken;
  } catch (err) {
    console.error("getMSMeetingId error:", err?.response?.data ?? err.message ?? err);
    return null;
  }
};

// In component
useEffect(() => {
  // Call once when component mounts.
  getMSMeetingId();

  // initialize only if you need other Teams SDK interactions here.
  // Don't call initialize redundantly.
  // microsoftTeams.app.initialize().catch(err => console.error("Teams init failed", err));
}, []);
 

  

  // For local comment the code to here

  // =====================================user  loggout code end==============================

  // =====================================Organization and team code start==============================
  const [team, setTeam] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");
  const [hasTeam, setHasTeam] = useState(false);
  // const [orgName, setOrgName] = useState("");
  // const [orgLogo, setOrgLogo] = useState("");

  const fetchTeam = async (workspace_id) => {
    const team_url = `${dashboard_backend}/team/workspaces/${workspace_id}/team/`;
    const refreshToken = sessionStorage.getItem("refresh_token");
    const accessToken = sessionStorage.getItem("access_token");
    if (!refreshToken) {
      navigate("/login");
      return;
    }
    try {
      const team_response = await axios.get(team_url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (team_response.status === 200) {
        if (team_response.data.length > 0) {
          setHasTeam(true);
          setTeam(team_response.data);
          setSelectedTeam(team_response.data[0].team_name);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getOrganiztion = async () => {
    const organization_url = `${dashboard_backend}/team/workspaces/`;

    const refreshToken = sessionStorage.getItem("refresh_token");
    const accessToken = sessionStorage.getItem("access_token");
    if (!refreshToken) {
      navigate("/login");
      // setIsLoading(false);
      return;
    }
    try {
      const organiztion_response = await axios.get(organization_url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (organiztion_response.status === 200) {
        if (organiztion_response.data.length !== 0) {
          sessionStorage.setItem(
            "Organization_detail",
            JSON.stringify(organiztion_response.data)
          );
          setHasOrganization(true);
          fetchTeam(organiztion_response.data[0].id);
          // setOrgName(organiztion_response.data[0].name);
          // setOrgLogo(organiztion_response.data[0].logo);
        }
        if (organiztion_response.data.length === 0) {
          sessionStorage.removeItem("Organization_detail");
          setHasOrganization(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
    setOrgLoaded(true);

  };

  useEffect(() => {
    // commented for frontend devlopmment / local purpose @prosenjit
    getOrganiztion();
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshData = async () => {
    // setIsLoading(true);

    try {
      await checkAuth(); // Revalidate auth and tokens
      await getOrganiztion(); // This internally calls fetchTeam()


      // setIsLoading(false);
    } catch (err) {
      console.error("Error refreshing data:", err);
      // setIsLoading(false);
      toast("Failed to refresh data");
    }
  };

  useEffect(() => {
    if (!hasOrganization || !hasTeam) {
      const timeout = setTimeout(() => {
        refreshData(); // runs once after 3 seconds
      }, 5000);

      return () => clearTimeout(timeout); // cleanup if component unmounts early
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleLogout = async () => {
    const url = `${ext_backend}logout/`;
    const refreshToken = sessionStorage.getItem("refresh_token");
    const accessToken = sessionStorage.getItem("access_token");

    // const refreshToken = refresh_token
    // const accessToken = access_token

    if (!refreshToken) {
      navigate("/login");
      return;
    }

    axios
      .post(
        url,
        { refresh: refreshToken },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((res) => {
        // alert("Logout successful");
        toast("Logout successful");

        // Clear tokens from local storage
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("refresh_token");
        sessionStorage.removeItem("username");
        sessionStorage.removeItem("display_name");
        sessionStorage.removeItem("role");
        sessionStorage.removeItem("Organization_detail");
        sessionStorage.removeItem("org_name");

        // chrome.identity.getAuthToken({ interactive: false }, (token) => {
        //   if (token) {
        //     chrome.identity.removeCachedAuthToken({ token }, () => {
        //       // Optionally redirect to login page after logout
        //       navigate("/login");
        //     });
        //   }
        // });

        // Redirect to the login page or another page after logout
        navigate("/login");
      })
      .catch((error) => {
        console.log("Error:", error);
        // alert("Logout failed");
        toast("Logout failed");
      });
  };
  // ============================================user  loggout  code end==============================

  // ==================================user check logged in or not code start==============================

  const checkAuth = async () => {
    try {
      // Get the access token from local storage

      const accessToken = sessionStorage.getItem("access_token");
      // const refreshToken = sessionStorage.getItem("refresh_token");

      // Fetch the active tab's URL

      // setIsLoading(true);

      // Make a request to the user endpoint with the access token
      const response = await axios.get(`${ext_backend}user/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.status === 200) {
        sessionStorage.setItem("display_name", response.data.first_name);
        sessionStorage.setItem("username", response.data.username);
        sessionStorage.setItem("user_id", response.data.id);
        sessionStorage.setItem("user_email", response.data.email);

        let creator = null;
        try {
          creator = JSON.parse(sessionStorage.getItem("Organization_detail"));
        } catch (e) {
          console.error("Error parsing Organization_detail:", e);
        }

        if (
          creator &&
          Array.isArray(creator) &&
          creator.length > 0 &&
          creator[0].created_by === response.data.id
        ) {
          sessionStorage.setItem("org_name", creator[0].name);
          sessionStorage.setItem("org_logo", creator[0].logo);
          sessionStorage.setItem("role", "creator");
        } else {
          sessionStorage.removeItem("org_name");
        }

        if (sessionStorage.getItem("rate_count")) {
          sessionStorage.setItem(
            "rate_count",
            Number(sessionStorage.getItem("rate_count")) + 1
          );
        } else {
          sessionStorage.setItem("rate_count", 1);
        }
        setTimeout(() => {
          // setAuthenticated(true);
          setAuthLoaded(true);
        }, 1000);
      }

      // If the response is successful, the user is authenticated
    } catch (error) {
      const refreshToken = sessionStorage.getItem("refresh_token");
      setAuthLoaded(true);
      if (error.response && error.response.status === 401 && refreshToken) {
        try {
          // Try to refresh the token
          const tokenResponse = await axios.post(
            `${ext_backend}api/token/refresh/`,
            {
              refresh: refreshToken,
            }
          );
          const newAccessToken = tokenResponse.data.access;
          const newRefreshToken = tokenResponse.data.refresh;
          sessionStorage.setItem("access_token", newAccessToken);
          sessionStorage.setItem("refresh_token", newRefreshToken);
          // setIsLoading(false);
          // Retry the original request with the new access token
          // const retryResponse = await axios.get(`${ext_backend}user/`, {
          //   headers: { Authorization: `Bearer ${newAccessToken}` },
          // });

          // If the retry is successful, the user is authenticated
        } catch (refreshError) {
          // If refreshing the token fails, navigate to login
          
          sessionStorage.removeItem("access_token");
          sessionStorage.removeItem("refresh_token");
          setTimeout(() => {
            navigate("/login");
            // setIsLoading(false);
          }, 1000);
        }
      } else {
        // If no refresh token is found or another error occurs, log the user out
        // setAuthenticated(false);
        setTimeout(() => {
          navigate("/login");
          // setIsLoading(false);
        }, 1000);
        console.log("Authentication check error:", error);
      }
    }
  };

  // =================================user check logged in or not code end==============================

  //==============================Get Session Data for navigate user on group room code start ====================
  // 09/11/2024
  useEffect(() => {
    let api = `${ext_backend}sessionget/`; //code change for testing
    const user = sessionStorage.getItem("username");
    const roomcode = sessionStorage.getItem("roomcode");
    const meeting_active = JSON.parse(sessionStorage.getItem("meeting_active"));
    if(meeting_active === true && roomcode ){
      const params = {
        username: user,
        roomcode: roomcode,
        meeting_active: meeting_active
      };
      axios
        .get(api, { withCredentials: true, params: params })
        .then((res) => {
          if (res.data.data.roomcode != null) {
            navigate("../VoiceToText");
          }
        })
        .catch((error) => {
          console.error("Error retrieving data:", error);
        });
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //==============================Get Session Data f code end =============================================================================

  const dispatch = useDispatch(value(input));

  // Getting Unique Code for meeting work as room code if full meeting link provided
  const getUniqueId = (meetUrl) => {
    if (meetUrl.includes("teams.microsoft.com")) {
      const decodedUrl = decodeURIComponent(meetUrl);
      const match = decodedUrl.match(/meetup-join\/19:meeting_([A-Za-z0-9-]+)@/);
      if (match) {
        return match[1];
      }
      return null;
    } else if (meetUrl.includes("meet.google.com")) {
      return meetUrl.split("https://meet.google.com/")[1] || null;
    } else {
      console.warn(`No meeting ID found in the URL: ${meetUrl}`);
      return null;
    }
  }

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value.trim();

    let uniqueId = value;
    let meetUrl = value;

    if (value.includes("teams.microsoft.com")) {
      uniqueId = getUniqueId(value).slice(0, 10); // Get the first 10 characters of the unique ID
      if (uniqueId) {
        const decodedUrl = decodeURIComponent(value);
        const extra = decodedUrl.split("meetup-join/")[1];
        meetUrl = `https://teams.microsoft.com/v2/?meetingjoin=true#/l/meetup-join/${extra}`;
        sessionStorage.setItem("meeting_link", meetUrl);
        sessionStorage.setItem("channel", "Microsoft Teams");
      }
    }
    else if (value.includes("meet.google.com")) {
      uniqueId = getUniqueId(value);
      meetUrl = value; // Google Meet link stays the same
      sessionStorage.setItem("meeting_link", meetUrl);
      sessionStorage.setItem("channel", "Google Meet");
    }
    else if (value.includes("https://") && !value.includes("meet.google.com") && !value.includes("teams.microsoft.com")) {
      return toast.error("Please enter a valid Google Meet or Microsoft Teams link.");
    }
    else {
      sessionStorage.removeItem("meeting_link");
      sessionStorage.removeItem("channel");
    }
    

    setInput((values) => ({ ...values, [name]: uniqueId }));
  };

  useEffect(() => {
    setInput({ roomcode: meetUrl });
    sessionStorage.removeItem("meeting_link");
    sessionStorage.removeItem("channel");
  }, [meetUrl]);

  // const storeRoomSessionData = async (input, selectedTeam, team, redirect) => {
  //   chrome.runtime.sendMessage({ action: "getActiveTab" }, (response) => {
  //     console.log("Active tab response:", response);
  //     if (response.tab) {
  //       const { id: tabId } = response.tab;
  //       // Do something with the active tab ID
  //       console.log("Active tab ID:", tabId);
  //     }
  //   });
  //   const name = sessionStorage.getItem("username") || "guest";
  //   // Build unique room code: username + timestamp + optional random string
  //   const timestamp = new Date().toISOString().replace(/[-:.]/g, ""); // remove special chars
  //   const randomStr = Math.random().toString(36).substring(2, 6); // 4 random chars
  //   const unique_room_code = `${name}_${timestamp}_${randomStr}`;
  //   sessionStorage.setItem("education_room_code", unique_room_code);
  //   if (selectedTeam) {
  //     const team_id = team.find((item) => item.team_name === selectedTeam);
  //     sessionStorage.setItem("team_id", team_id.id);
  //     sessionStorage.setItem("team_name", selectedTeam);
  //   }
  //   let team_id = sessionStorage.getItem("team_id");

  //   if (team_id) {
  //     console.log("Fetching role for team ID:", team_id);


  //     await axios
  //       .get(`${dashboard_backend}team/workspaces/role/${team_id}/`, {
  //         headers: {
  //           Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
  //         },
  //       })
  //       .then((res) => {
  //         sessionStorage.setItem("role", res.data.role);
  //         if (res.data.role) {
  //           const organization = JSON.parse(
  //             sessionStorage.getItem("Organization_detail")
  //           );
  //           sessionStorage.setItem("org_name", organization[0].name);
  //           sessionStorage.setItem("org_logo", organization[0].logo);
  //           sessionStorage.setItem("team_name", res.data.team_name);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error retrieving data:", error);
  //       });
  //   }
  //   chrome.runtime.sendMessage({ action: "getActiveTab" }, (response) => {
  //     if (response.tab) {
  //       const { id: tabId } = response.tab;
  //       // Do something with the active tab ID
  //       console.log("Active tab ID:", tabId);
  //     }
  //   });
  //   const date = new Date().toISOString();
  //   const unqiue_room_code =
  //     navigate(redirect)
  // };

  const handleCreateRoom = async () => {
    const name = sessionStorage.getItem("username");
    let api = `${ext_backend}sessionsave/`; //code change for testing
   

    if (selectedTeam) {
      const team_id = team.find((item) => item.team_name === selectedTeam);
      sessionStorage.setItem("team_id", team_id.id);
      sessionStorage.setItem("team_name", selectedTeam);
    }
    let team_id = sessionStorage.getItem("team_id");
    if (team_id) {
      await axios
        .get(`${dashboard_backend}team/workspaces/role/${team_id}/`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          sessionStorage.setItem("role", res.data.role);
          if (res.data.role) {
            const organization = JSON.parse(
              sessionStorage.getItem("Organization_detail")
            );
            sessionStorage.setItem("org_name", organization[0].name);
            sessionStorage.setItem("org_logo", organization[0].logo);
            sessionStorage.setItem("team_name", res.data.team_name);
          }
        })
        .catch((error) => {
          console.error("Error retrieving data:", error);
        });
    }



    await axios
      .post(
        api,
        { roomcode: input.roomcode, username: name },
        { withCredentials: true }
      )
      .then((res) => {
        // alert("Data saved!");
        // toast("Data saved!");
        dispatch(value(input));
        sessionStorage.setItem("roomcode", input.roomcode);
        sessionStorage.setItem("meeting_active", true);
        navigate("../VoiceToText");
      })
      .catch((error) => {
        console.error("Error saving data:", error);
      });
  };

  useEffect(() => {
    // commented for frontend devlopmment / local purpose @prosenjit
    checkAuth();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // if (authenticated === false) {
  //     return <div>please first login</div>; // or a spinner
  // }

  // setTimeout(() => {
  //     setLoginMessage(false);
  // }, 2000);

  const handleTeam = (event) => {
    setSelectedTeam(event.target.value);

    // const user_id = sessionStorage.getItem('user_id');
    // const creator = JSON.parse(sessionStorage.getItem("Organization_detail"))[0].created_by
    // if (user_id === creator) {
    //     sessionStorage.setItem("team", event.target.value);
    // }
  };

  // Fetching the Calendar meetings

  const fetchCalendarMeetings = useCallback(async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      if (!accessToken) throw new Error("Access token not found");

      const response = await axios.get(`${auth_backend}today-meetings/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching calendar meetings:", error);
      return [];
    }
  }, [auth_backend]);

  useEffect(() => {
  const fetchData = async () => {
    if (skipCalendarMeetings) {
      setCalendarLoaded(true);
      return;
    }

    try {
      const data = await fetchCalendarMeetings();
      setGoogleCalendarMeetings(data.meetings || []);

      //  Only update skipCalendarMeetings if it’s *actually different*
      if ((data.meetings && data.meetings.length > 0 && skipCalendarMeetings) ||
          ((!data.meetings || data.meetings.length === 0) && !skipCalendarMeetings)) {
        setSkipCalendarMeetings(data.meetings?.length > 0 ? false : true);
      }

    } catch (error) {
      console.error("Failed to fetch calendar meetings:", error);
      setGoogleCalendarMeetings([]);
    } finally {
      setCalendarLoaded(true);
    }
  };

  fetchData();
}, [fetchCalendarMeetings, skipCalendarMeetings]);


  // Get Credits
  const [userCredits, setUserCredits] = useState(null);
  const [creditsFetched, setCreditsFetched] = useState(false);
  const [creditsExhausted, setCreditsExhausted] = useState(false);
  const get_credits = async () => {
    try {

      const response = await axios.get(
        `${dashboard_backend}/wallet/get-credits-details/`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.status === 200) {
        const data = response.data.data;
        const totalCredits = (Number(data.credits_assigned) + Number(data.user_addon?.addon_credits || 0)).toFixed(2);
        setUserCredits(totalCredits);
        if (totalCredits <= 0) {
          setCreditsExhausted(true);
        }

        setCreditsFetched(true);
      }
    }
    catch (error) {
      console.error(error);
    }
    finally {
      setCreditsFetched(true);
    }
  }
  useEffect(() => {
    get_credits();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const derivedLoading = !(authLoaded && orgLoaded && calendarLoaded && creditsFetched);

  const [showMeetingPopup, setShowMeetingPopup] = useState(false);
  const [meetingAnchorEl, setMeetingAnchorEl] = useState(null);

  const handleMeetingButtonClick = (event) => {
    setMeetingAnchorEl(event.currentTarget);
    setShowMeetingPopup(true);
  };
  const handleMeetingPopupClose = () => {
    setMeetingAnchorEl(null);
    setShowMeetingPopup(false);
  }

  return (
    <>
      <center style={{ position: "relative" }}>
        <div class="max-w-2xl items-center justify-center p-2 z-20 from-base-100 via-base-100/10 to-base-100/5 flex backdrop-blur-md bg-opacity-90 flex flex-col " style={{ position: 'relative' }}>
          {!derivedLoading && userCredits && <CreditsBadge credits={userCredits} dashboard={dashboard} />}
          <div className="w-full md:w-2/2 items-center justify-center  flex-col">
            
            {!derivedLoading ? (
              <>
                <div className="all-center flex flex-col  py-4 md:py-8 space-y-3 md:space-y-2 w-full max-w-xs ">

                    <div style={{ position: "relative" }}>
                      {/* Meeting ID Input */}
                      <h1 className="py-[10px] text-left text-[14px] font-medium">
                        Enter your meeting ID:
                      </h1>
                      <input
                        type="text"
                        name="roomcode"
                        value={input.roomcode}
                        onChange={handleInput}
                        className="w-full py-2 px-3 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:border-blue-300"
                      />

                      {/* Team Selection */}
                      {team && team.length > 0 && (
                        <div>
                          <label
                            style={{
                              float: "left",
                              fontWeight: "500",
                              fontSize: "14px",
                              padding: "10px 0px",
                            }}
                          >
                            Select Your Team:
                          </label>
                          <Select
                            value={selectedTeam || (team.length > 0 ? team[0].team_name : "")}
                            onChange={handleTeam}
                            sx={{ width: "100%", color: "black" }}
                          >
                            {team.map((item, index) => (
                              <MenuItem key={index} value={item.team_name}>
                                {item.team_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      )}

                      {/* Join Button or No Org/Team */}
                      {hasOrganization && hasTeam ? (
                        <center>
                          <button
                            disabled={(selectedTeam === "" && team.length > 0) || creditsExhausted}
                            onClick={handleCreateRoom}
                            className={
                              `w-full text-white shadow-xl py-2 px-4 mt-2 rounded-lg !bg-[#68548E] !normal-case !text-[#ffffff] join-room ` +
                              (creditsExhausted ? "opacity-50 cursor-not-allowed pointer-events-none" : "hover:scale-[1.02] transition-transform")
                            }
                          >
                            Join Room
                          </button>

                          {/* <button
                            disabled={creditsExhausted}
                            onClick={() => {
                              storeRoomSessionData(input, selectedTeam, team, "/education");
                            }}
                            // keep the inline 'position: relative' you had
                            className={
                              `w-full text-gray-800 bg-[#e0e0e0] py-2 px-4 mt-6 rounded-lg font-medium border transition duration-200 ` +
                              (creditsExhausted ? "opacity-50 cursor-not-allowed pointer-events-none" : "hover:bg-gray-200")
                            }
                            style={{ borderColor: "#5a3e91", position: "relative" }}
                          >
                            🚀 Quick Learning Mode
                            <i
                              className="fas fa-info-circle"
                              style={{
                                marginLeft: "6px",
                                fontSize: "1.2em",
                                verticalAlign: "middle",
                                color: "#5a3e91",
                              }}
                              title="Learn in real time, without bots or speaker IDs"
                            />
                            <span className="beta-badge">Beta</span>
                          </button> */}
                        </center>
                      ) : (
                        <div>
                          <h1 className="py-[15px] text-center text-[16px]">
                            {!hasOrganization
                              ? `You don't have any Organization`
                              : `You're currently a lone ranger! Get added to a team. Ask your admin today!`}
                          </h1>

                          <Link to={dashboard} target="_blank">
                            <button className="w-full !rounded-full p-2 !bg-[#68548E] !normal-case !text-[#ffffff]">
                              {!hasOrganization
                                ? `Create Your Organization`
                                : `Create or check invite mail`}
                            </button>
                          </Link>
                        </div>
                      )}
                    </div>

                </div>
                <div>
                  <button
                    onClick={handleLogout}
                    className="text btn hover:text-blue-700 power"
                  >
                    <img
                      src={power}
                      className="w-[40px] h-[40px] rounded-full hover:scale-110 transition duration-300"
                      title="Logout"
                      alt="logo"
                    />
                  </button>
                </div>
              </>
            ) : (
              <Loader />
            )}
          </div>
          
        </div>

        {!derivedLoading && (
          <div>
            Powered by{" "}
            <img
              src={liznr_logo}
              className="w-[70px] h-[30px] image"
              alt="logo"
            />
          </div>
        )}
        {!derivedLoading && googleCalendarMeetings && googleCalendarMeetings.length ===0 && <div
          className="absolute right-4 bottom-4 md:right-6 md:bottom-6"
          style={{ zIndex: 60 }}
        >
          <MeetingPopover
            showMeetingPopup={showMeetingPopup}
            meetingAnchorEl={meetingAnchorEl}
            handleMeetingButtonClick={handleMeetingButtonClick}
            handleMeetingPopupClose={handleMeetingPopupClose}
            setShowMeetingPopup={setShowMeetingPopup}
          />
        </div>}
      </center>
    </>
  );
};

export default CreateRoom;
